import Axios from "../../../utils/axios";

export const getPassportClaims = (data) => {
    return (dispatch) => {
        Axios.get("/passport-claims", dispatch, "GET_PASSPORT_CLAIMS", data);
    };
};
